import * as React from 'react'

import Link from 'next/link'
import { Card, List } from 'tabler-react'

interface Props {
  recentJobs: []
}

class JobDetailsRecentJobs extends React.Component<Props> {
  constructor(props){
    super(props)

    this.makeTitle = this.makeTitle.bind(this)
  }

  makeTitle(title) {
    return title.split(' ').filter(function (name) {
      return name !== '-'
    }).toString().replace(/,/g, '-')
  }

  render () {
    const {
      recentJobs
    } = this.props

    return (
      <Card className='job-details-card'>
        <Card.Header>
          <Card.Title>
            Recent Jobs
            </Card.Title>
        </Card.Header>
        <Card.Body>
          <List unstyled>
            {
              recentJobs.slice(0,5).map((job:any, i) => {
                return (
                  <List.Item key={i}>
                    <Link as={`/job/${this.makeTitle(job.job_details[0].job_title) + '-' + job.job_details[0].job}`} href={`/job?id=${this.makeTitle(job.job_details[0].job_title) + '-' + job.job_details[0].job}`}>
                      {job.job_details[0].job_title}
                    </Link>
                    <p>
                      {job.job_details[0].job_description.substring(0, 45)}
                    </p>
                  </List.Item>
                )
              })
            }
          </List>
        </Card.Body>
      </Card>
    )
  }
}

export default JobDetailsRecentJobs